module.exports = __webpack_public_path__ + "static/media/button-video-play.574d8c26.svg";